import { hexToGrayscale } from "../functions";
import { DataTable } from "../types";

export const buildDataSheetHTML = async (dataSheet: DataTable) => {
  if ((dataSheet?.tables || [])?.length === 0) return "";

  return dataSheet?.tables
    ?.map((table) => {
      const header_color = table?.header_color || "#d1c4e9";
      const columns = table?.columns || [];
      const rows = table?.rows || [];

      return `<div class="relative mt-8">
  <p class="text-2xl font-bold">${
    table.name
  } <span class="text-[#808080] text-neutral-500">(${
        table.description
      })</span></p>
  <div class="relative mt-5">
<table class="table-fixed">
    <thead>
        <tr class="text-[${
        hexToGrayscale(header_color) > 150 ? "#000000" : "#FFFFFF"
      }]" style="background-color: ${header_color};">
        <th class="pl-2 py-2 text-md text-left break-all max-w-[50pt] min-w-[50pt] w-[50pt]">S.No</th>
        ${columns
          ?.map((col) => {
            return `<th class="pl-2 py-2 text-md text-left break-all max-w-[${
              col?.width || 200
            }pt] min-w-[${col?.width || 200}pt] w-[${col?.width || 200}pt]">${
              col.header_name
            }</th>`;
          })
          .join("")}
        </tr>
    </thead>

    <tbody>
    ${
      rows
        ?.map((row, idx) => {
          const currentRow = row?.column_content || [];
          let curr = "";
          curr += `<tr class="${
            idx % 2 === 0 ? "bg-gray-50" : "bg-gray-100"
          }">`;
          curr += `<td class="px-2 py-2 text-md min-w-[50pt] max-w-[50pt] w-[50pt]">${
            idx + 1
          }</td>`;
          curr += currentRow
            ?.map(
              (v: any, id) =>
                `<td class="px-2 py-2 text-md min-w-[${
                  columns?.[id].width || 200
                }pt] max-w-[${columns?.[id].width || 200}pt] w-[${
                  columns?.[id].width || 200
                }pt]">${v.content}</td>`
            )
            .join("");

          curr += `</tr>`;

          return curr;
        })
        ?.join("") ?? ``
    }
    </tbody>
</table>
</div>
</div>`;
    })
    .join("");
};
